import React from "react";
import ReactLoading from "react-loading";
import "./style.css";

const Loader = ({ isLoading }) => {
  return (
    <div className="loader" style={{ display: isLoading ? "flex" : "none" }}>
      <ReactLoading
        type="spinningBubbles"
        color="#fff"
        height={100}
        width={100}
      />
    </div>
  );
};

Loader.defaultProps = {
  isLoading: false,
};

export default Loader;
